import React, { useEffect, useState } from "react";
import "../Gallary/SampleGallary.css";


import Image1 from "./Images/Img27.jpg";
import Image2 from "./Images/Img28.jpg";
import Image3 from "./Images/Img29.jpg";
import Image4 from "./Images/Img30.jpg";
import Image5 from "./Images/Img31.jpg";
import Image6 from "./Images/Img32.jpg";
import Image7 from "./Images/Img33.jpg";
import Image8 from "./Images/Img34.jpg";
import Image9 from "./Images/Img35.jpg";
import Image10 from "./Images/Img36.jpg";
import Image11 from "./Images/Img37.jpg";
import Image12 from "./Images/Img38.jpg";
import Image13 from "./Images/Img39.jpg";
import Image14 from "./Images/Img40.jpg";
import Image15 from "./Images/Img41.jpg";
import Image16 from "./Images/Img42.jpg";
import Image17 from "./Images/Img43.jpg";
import Image18 from "./Images/Img44.jpg";
import Image19 from "./Images/Img45.jpg";
import Image20 from "./Images/Img46.jpg";
import Image21 from "./Images/Img47.jpg";
import Image22 from "./Images/Img48.jpg";
import Image23 from "./Images/Img49.jpg";
import Image24 from "./Images/Img50.jpg";
import Image25 from "./Images/Img51.jpg";
import Image26 from "./Images/Img52.jpg";
import Image27 from "./Images/Img53.jpg";

const images = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image17,
  Image18,
  Image19,
  Image20,
  Image21,
  Image22,
  Image23,
  Image24,
  Image25,
  Image26,
  Image27,
];

const SampleGallary1 = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imagesToShow, setImagesToShow] = useState(5); // Default to 5

  const updateImagesToShow = () => {
    if (window.innerWidth <= 600) {
      setImagesToShow(3); // Show 3 images for mobile size
    } else {
      setImagesToShow(5); // Show 5 images for larger screens
    }
  };

  useEffect(() => {
    updateImagesToShow(); // Set initial images to show
    window.addEventListener("resize", updateImagesToShow); // Update on resize
    return () => window.removeEventListener("resize", updateImagesToShow);
  }, []);

  const nextImages = () => {
    setCurrentIndex((prevIndex) =>
      Math.min(prevIndex + imagesToShow, images.length - imagesToShow)
    );
  };

  const prevImages = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - imagesToShow, 0));
  };

  return (
    <div className="gallery-container">
      <button
        className="Garrow left"
        onClick={prevImages}
        disabled={currentIndex === 0}
      >
        &lt;
      </button>
      {images
        .slice(currentIndex, currentIndex + imagesToShow)
        .map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Gallery  ${currentIndex + index + 1}`}
            className="gallery-image"
            loading="lazy"
          />
        ))}
      <button
        className="Garrow right"
        onClick={nextImages}
        disabled={currentIndex + imagesToShow >= images.length}
      >
        &gt;
      </button>
    </div>
  );
};

export default SampleGallary1;
